export default __webpack_public_path__ + "static/media/astonished.4bafb733.png";